import React from "react";
import { Carousel, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function ModuleCarousel(props) {
    /**
     * Component containing moving carousel of select modules from the training list in the master JSON.
     * @param : carousel index to retrieve the proper training from the list, event handler, and training list.
     * @returns: rotating module carousel JSX component, each element having the thumbnail and title text of a carousel training
     */

    return (
        <Row className="justify-content-center dark-bg1-sport">
            <div className="d-inline-block">
                <div className="card" style={{backgroundColor: "black"}}>
                    <Carousel activeIndex={props.carouselIndex} onSelect={props.carouselHandler} indicators={false}>
                        {props.trainings.map(training => {
                            const name = Object.keys(training)[0];
                            
                            return (
                                <Carousel.Item key={name}>
                                    <Link to={`/${name}`}>
                                        <img className="d-block" style={{margin: "auto", width: "auto", height: "256px"}} alt="" src={training[name]["thumbnail"]}/>
                                    
                                        <Carousel.Caption className="d-none d-md-block training-cbanner-sport">
                                            <h4>{training[name]["title"]}</h4>
                                        </Carousel.Caption>
                                    </Link>
                                </Carousel.Item>
                            );
                        })}                            
                    </Carousel>
                </div>
            </div>
        </Row>
    );
}

export default ModuleCarousel;